import { Dispatch, ThunkAction } from '../../../../../../../types/actions';
import { IGetState } from '../../../../../../../types/types';
import { FEATURE_POLL_FIRST_VISIT_COOKIE_NAME, TEMPLATE_BOARD_ID_SESSIONSTORAGE } from '../constants';
import { root } from '../../../../../../../store/constants';
import { dispatch } from '../../../../../../../store/configureStore';
import { segmentTrackAction, SegmentUserEvent } from '../../../../../../../middlewares/segment';

export const onSkip = (): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        dispatch(segmentTrackAction(SegmentUserEvent.TEMPLATE_POLL_SKIPPED));
        sessionStorage.removeItem(TEMPLATE_BOARD_ID_SESSIONSTORAGE);
        root.App.Util.setCookie(FEATURE_POLL_FIRST_VISIT_COOKIE_NAME, true);
        root.App.controller.removeTemplatePoll();
    };
    return action;
};
